export default {
  KYC: 1,
  ConnectToShipBob: 2,
  ConfigureFulfillment: 3,
  ImportOrders: 4
}
